import { useMemo } from "react";
import * as yup from "yup";
import { useDataSelectionContext } from "./DataSelectionContext";
import { WfsGetFeatureRequest } from "../../types/Wfs/WfsGetFeatureRequest";
import DataSelectionModel from "./DataSelectionModal";
import { Form } from "react-bootstrap";

interface NaptanFormValues {
    outputFormat: string;
}

const Naptan = () => {
    const layerName = "basemap:Naptan";
    const { layers, getLayer, wfsOrder } = useDataSelectionContext();
    const layer = useMemo(() => getLayer(layerName), [layers]);
    const initialValues = useMemo(
        () =>
        ({
            outputFormat: "csv",
        } as NaptanFormValues),
        [layer],
    );
    const schema = useMemo(
        () =>
            yup.object({
                outputFormat: yup.string().oneOf(["csv", "gml"]).required(),
            }),
        [layer],
    );

    const onSubmit = (values: NaptanFormValues) => {
        wfsOrder({
            service: "WFS",
            version: "2.0.0",
            request: "GetFeature",
            resultType: "Results",
            typeNames: layerName,
            outputFormat: values.outputFormat,
        } as WfsGetFeatureRequest);
    };

    return (
        <DataSelectionModel
            headerText="NaPTAN"
            layer={layer}
            initialValues={initialValues}
            validationSchema={schema}
            onSubmit={onSubmit}>
            {({ values, handleChange, handleBlur }) => (
                <>
                    <Form.Group>
                        <Form.Label htmlFor="outputFormat">Format</Form.Label>
                        <Form.Select
                            id="outputFormat"
                            name="outputFormat"
                            value={values.outputFormat}
                            onChange={handleChange}
                            onBlur={handleBlur}>
                            <option value="gml">GML 3</option>
                            <option value="csv">CSV</option>
                        </Form.Select>
                    </Form.Group>
                </>
            )}
        </DataSelectionModel>
    );
}

export default Naptan;